import {
  createPlugin,
  createRoutableExtension,
  createComponentExtension,
} from '@backstage/core-plugin-api';

import { rootRouteRef } from './routes';

export const deploymentManagerPlugin = createPlugin({
  id: 'deployment-manager',
  routes: {
    root: rootRouteRef,
  },
});

export const DeploymentManagerPage = deploymentManagerPlugin.provide(
  createRoutableExtension({
    name: 'DeploymentManagerPage',
    component: () =>
      import('./components/DeployManifest').then(m => m.DeployManifest),
    mountPoint: rootRouteRef,
  }),
);

export const DeploymentsEntityContentExtension =
  deploymentManagerPlugin.provide(
    createComponentExtension({
      name: 'DeploymentsEntityContent',
      component: {
        lazy: () =>
          import('./components/DeployManifest').then(m => m.DeployManifest),
      },
    }),
  );
